import React, {useCallback, useEffect, useMemo, useState} from 'react';
import parse from 'html-react-parser';
import Spinner from 'js/components/Common/Spinner/Spinner';
import Input from 'js/components/Common/FormComponents/Input/Input';
import useFetchCallback from 'js/hooks/useFetchCallback/useFetchCallback';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import classes from './SingleInterestsCheckbox.module.pcss';
import fetchData from './fetchData';
import MixPanelWrapper from 'js/servises/MixPanelWrapper';

interface Props {
    grId: string,
    databaseId: string,
    name: string
}

const SingleInterestsCheckbox = ({grId, databaseId, name}: Props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [status, setStatus] = useState<boolean>(false);
    const [showMessage, setShowMessage] = useState<boolean>(false);

    const labelText = useMemo(() => {
        if (status) {
            return parse(`You Added ${name}`);
        }
        return parse(`Add <strong>${name}</strong> To My Interests`);
    }, [name, status]);

    const messageText = useMemo(() => {
        if (status) {
            return parse(`You've just added <strong>${name}</strong> to My Interests!<br><a href="/profile">View My Interests</a>.`);
        }
        return parse(`You've removed <strong>${name}</strong> from My Interests! <br><a href="/profile">View My Interests</a>.`);
    }, [name, status]);

    const sendMixPanelCheckBoxEvent = useCallback(async (checked, productName: string) => {
        await MixPanelWrapper.TrackEvent(
            'Interests checkbox is clicked',
            {
                category: 'Home page',
                section: 'Explore section',
                selected: checked ? 'yes' : 'no',
                value: productName
            });
    }, []);

    const changeProductAction = useFetchCallback({
        updateData: data => data,
        query: ():string => `${fetchData(parseInt(databaseId), grId, status ? 'remove' : 'add')}`,
        onStart: () => setIsLoading(true),
        onSuccess: async () => {
            setStatus(prev => !prev);
            await sendMixPanelCheckBoxEvent(!status, name);
            setIsLoading(false);
            setShowMessage(true);
        },
        onFailure: () => setIsLoading(false),
        onError: () => setIsLoading(false)
    });


    useEffect(() => {
        let timer;
        if (showMessage) {
            timer = setTimeout(() => {
                setShowMessage(false);
            }, 4000);
        }

        return () => clearTimeout(timer);
    }, [showMessage]);


    return (
        <DataValidator data={grId?.length > 0 && databaseId?.length > 0 && name?.length > 0}>
            <div className={`${classes.SingleInterestsCheckbox} ${status ? classes.Active : ''} ${isLoading ? classes.Loading : ''}`}>
                <>
                    <Spinner type={'blue'} size={'small'}/>
                    <Input
                        slug={name}
                        id={databaseId}
                        onChange={changeProductAction}
                        type={'checkbox'}
                        checked={status}
                        withLabel={true}
                        labelText={labelText}/>
                    <div className={`${classes.Message} ${showMessage ? classes.Active : ''}`}>
                        {messageText}
                    </div>
                </>
            </div>
        </DataValidator>
    );
};

export default SingleInterestsCheckbox;
